angular.module('iw.frontyard.common')
    .service('IwocaUrlHelper', function() {

        return {

            serializeParams : function(params) {
                var serializedParams = '?';
                for (var key in params) {
                    if (serializedParams != "?") {
                        serializedParams += "&";
                    }
                    serializedParams += key + "=" + encodeURIComponent(params[key]);
                }
                return serializedParams;
            },

            pushParamsToUrl : function(params) {
                window.history.pushState("", "", params);
            },

            deserializeParams: function(url, paramKey) {
                const urlParserRegex = /^(([^:\/?#]+):\/\/)?([^\/?#]*)?([^?#]*)(\?([^#]*))?(#(.*))?/;
                const queryParamSegment = urlParserRegex.exec(url)[6];

                if (queryParamSegment) {
                    const paramKeyValues = queryParamSegment.split(/&|=/);

                    let object = paramKeyValues.reduce(function(obj, v) {
                        let Vindex = paramKeyValues.indexOf(v)
                        if (Vindex % 2 === 0) obj[v] = paramKeyValues[Vindex+1];
                        return obj;
                    }, {});

                    return object[paramKey];
                }
            },

        };
    })